


























































































import {Vue, Component , Prop} from 'vue-property-decorator';
import { AutoCompleteData } from '@/store/models/Letter/AutoCompleteData';
import File from '@/store/models/Letter/File';
import LetterAttachmentMobile from '@/components/MobileComponents/LetterDetailsMobile/LetterAttachmentMobile/LetterAttachmentMobile.vue';
import * as util from '@/util/utils.ts';
import * as $ from 'jquery';
import FileSelector from '@/components/UiComponents/FileSelector.vue';
import * as autoCompleteDataService from '@/store/Services/autoCompleteDataService.ts';
import RecipientLookupMobile from '@/components/MobileComponents/ForwardLetterMobile/RecipientLookupMobile/RecipientLookupMobile.vue';
//import FastSendRecipientSelector from '@/components/Cartable/FastSend/FastSendRecipientSelector/FastSendRecipientSelector.vue';
import { LetterOwnerForSendingFaxAndEmailAndSms } from '../../../../../store/models/LetterOwner/LetterOwnerForSendingFaxAndEmailAndSms';
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import { LetterOwnerWithFaxAndEmails } from '../../../../../store/models/LetterOwner/LetterOwnerWithFaxAndEmails';
import CommentEditorMobile from '@/components/MobileComponents/ForwardLetterMobile/RecipientSelectorMobile/CommentEditorMobile/CommentEditorMobile.vue';

@Component({
    name:"FastSendSelectedRecipientMobile",
    components: { LetterAttachmentMobile, FileSelector, RecipientLookupMobile, CommentEditorMobile }
})
export default class FastSendSelectedRecipientMobile extends Vue{
    isTelegramActive = false;
    isMailActive = false;
    isSmsActive = false;
    get fileInputId(){
        if(this.recipient)
            return 'file-' + this.recipient.id;
        return '';
    }

    get dataListId(){
         if(this.recipient)
            return 'list-' + this.recipient.id;
        return '';
    }
    autoCompleteData = [] as AutoCompleteData[];
    @Prop() autoCompleteDataType?: string;
    @Prop() recipient?: LetterOwnerForSendingFaxAndEmailAndSms;
    @Prop() hideComment?: boolean;
    recipientRecipients = [] as LetterOwnerWithFaxAndEmails[]
    //selectedMainRecipients:  LetterOwnerForSendingFaxAndEmailAndSms [] = [];
    //selectedDraftRecipients:  LetterOwnerForSendingFaxAndEmailAndSms [] = [];
    //selectedCopyRecipients:  LetterOwnerForSendingFaxAndEmailAndSms [] = [];
    created(){
        if(this.recipient){
            const activeEmail = this.recipient.emails.find(x=>x.canBeUsedForSending);
            if(activeEmail)this.isMailActive = true;
        }
    }
    async mounted(){
        if(this.autoCompleteDataType === 'all')
            this.autoCompleteData =  await autoCompleteDataService.getForwardingAutoCompleteData();
        else if(this.autoCompleteDataType === 'copy')
            this.autoCompleteData = await autoCompleteDataService.getSendCopyAutoCompleteData();
        else if(this.autoCompleteDataType === 'draft')
            this.autoCompleteData = await autoCompleteDataService.getSendDraftAutoCompleteData();
        if(this.recipient)
            this.recipientRecipients = await letterOwnerService.getOwnerRecipients(this.recipient.id)
        
    }
    remove(){
        if(this.recipient)
            this.$emit('recipient-removed',this.recipient.id);
    }
    toggleTelegram(){
        if(!this.recipient)return;
        if(!this.recipient.canSendViaMessagingApp)return;
        this.recipient.shallSendViaMessagingApp = !this.recipient.shallSendViaMessagingApp;
    }
    toggleSms(){
        if(!this.recipient)return;
        if(!this.recipient.canUserSendSms)return;
        if(!this.recipient)return;
        this.recipient.shallSendSms = !this.recipient.shallSendSms
        
    }
    toggleMail(){
        if(!this.recipient)return;
        if(!this.recipient.canUserSendEmail)return;
        this.isMailActive = !this.isMailActive;
        if(this.recipient){
            if(this.recipient.emails){
                if(this.recipient.emails.length > 0 && this.isMailActive )
                    this.recipient.emails[0].canBeUsedForSending = true;
                else{
                    this.recipient.emails.forEach(mail=>{mail.canBeUsedForSending = false;});
                }
            }
        }
    }
    selectRecipient(recipient: LetterOwnerWithFaxAndEmails, listName: string){
        if(!this.recipient) return;
        let addedItem = null;
        if(this.recipient.childMainReceivers)
        addedItem =   this.recipient.childMainReceivers.find(item=>item.id === recipient.id);
        if(!addedItem && this.recipient.childCopyReceivers) 
            addedItem = this.recipient.childCopyReceivers.find(item=>item.id === recipient.id);
        if(!addedItem && this.recipient.childDraftReceivers)
            addedItem = this.recipient.childDraftReceivers.find(item=>item.id === recipient.id);  //this.selectedDraftRecipients.find(item=>item.id === recipient.id);
        if(!addedItem){
            if(listName === 'main' && this.recipient.childMainReceivers){
                this.recipient.childMainReceivers.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
            }
            else if(listName === 'copy' &&  this.recipient.childCopyReceivers){
                this.recipient.childCopyReceivers.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
            }
            else if(listName === 'draft' && this.recipient.childDraftReceivers){
                this.recipient.childDraftReceivers.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
            }
            
        }
            
    }
    onRecipientRemoved(id: string, listName: string){
        if(!this.recipient)return;
        let list = [] as LetterOwnerForSendingFaxAndEmailAndSms[] | undefined;
        if(listName == 'main'){
            list = this.recipient.childMainReceivers;
        }
        else if(listName == 'draft'){
            list = this.recipient.childDraftReceivers;
        }
        else if(listName == 'copy'){
            list = this.recipient.childCopyReceivers;
        }
        if(!list)return;
        const removedItem =  list.find(item=>item.id === id);
        if(!removedItem)return;
        const index =  list.indexOf(removedItem);
        list.splice(index,1);        
    }
    
   onCommentChanged(comment: string){
       if(!this.recipient)return;
       this.recipient.sendingComment = comment;
   }

    
   
}
